import { useState } from "react";
import CreatableSelect from "react-select/creatable";
import MUIChip from "../MUIChip/MUIChip";
import classes from "./MUIMultiTextInput.module.css";
import { InputLabel } from "@mui/material";


function MUIMultiTextInput({ label, value, onChange, onDelete, triggerWarning,discoveryCtx }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const handleInputChange = (val) => {
        setMenuOpen(val !== '');
    };

    const handleChange = (selectedOption) => {
        const selectedOptionValue = selectedOption.label;
        if (!value.some((val) => val.toLowerCase() === selectedOptionValue.toLowerCase())) {
            onChange(prevValue => [...prevValue, selectedOptionValue]);
        }
    };

    const handleOnCreate = (inputValue) => {
        if (value.length <= 2) {
            if (!value.some((val) => val.toLowerCase() === inputValue.toLowerCase())) {
                onChange(prevValue => [...prevValue, inputValue]);
            }
        } else {
            triggerWarning();
        }
    };

    const renderedValues = value?.map((val, index) => (
        <MUIChip key={index} label={val} className={classes.chip} onDelete={
            !discoveryCtx.is_launched
                ? () => onDelete(val)
                : undefined
        } />
    ));

    return (
        <div className={classes.container}>
            <InputLabel shrink htmlFor="input">{label}</InputLabel>

            <div className={classes.selectWrapper}>
                <CreatableSelect
                    value={null}
                    isDisabled={discoveryCtx.is_launched}
                    options={[]}
                    onInputChange={handleInputChange}
                    onChange={handleChange}
                    onCreateOption={handleOnCreate}
                    placeholder="Type and press enter..."
                    menuIsOpen={menuOpen}
                    components={{ DropdownIndicator: null }}
                    styles={{
                        control: (base) => ({
                            ...base,
                            minHeight: "2.4rem",
                            height: "2.4rem",
                            overflow: "hidden",
                            width: "100%",
                            marginTop: "-3px"
                        }),
                        input: (base) => ({
                            ...base,
                            maxWidth: "100%",
                            flex: "1 1 auto",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                        }),
                        container: (base) => ({
                            ...base,
                            width: "100%",
                            marginBottom: "5px",
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            maxWidth: "100%",
                            overflow: "hidden",
                        }),
                    }}
                />
            </div>

            <div className={classes.chipContainer}>
                {renderedValues}
            </div>
        </div>
    );
}

export default MUIMultiTextInput;
